import styled from "styled-components";

export const ContainerSpinner = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin: auto;
	height: 10rem;
`;
